import { Component, ViewChild, Output, EventEmitter, Input, OnInit, inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { HisAuthService, HisSearchFormComponent, HisUiService, HisJobStatus } from 'hisng';

@Component( {
    selector: 'psv-person-id-assignment-search-form',
    templateUrl: './person-id-assignment-search-form.component.html',
    standalone: false
} )
export class PersonIdAssignmentSearchFormComponent implements OnInit{
    auth = inject(HisAuthService);

    @ViewChild( HisSearchFormComponent, { static: true } ) searchFormComponent: HisSearchFormComponent;
    @Input() lastStartedJob: EventEmitter<HisJobStatus>;
    @Output() submitSearch = new EventEmitter();
    searchKeyword = new UntypedFormControl('');
    jobStatus: HisJobStatus;
    infoText = '';

    readonly SEARCH_CONFIG_PUBLICATION_ORCID_USER = '';
    public orcidLocalDokuPath = '/pages/cs/sys/portal/documentation/documentation.faces?&site=ORCID_Suche-HISinOne.xhtml';
    public href: string = window.location.href.substring(0, window.location.href.indexOf('/a/')) + this.orcidLocalDokuPath;

    constructor() {
        const hisUiService = inject(HisUiService);

        this.infoText = hisUiService.translate(
            'cs.psv.person.idAssignment.orcid.search.info',
            '<a href='+this.href+' target="_blank">',
            '</a>');
    }

    ngOnInit() {
        this.lastStartedJob.subscribe((status) => {
            this.jobStatus = status;
        });
    }

    onSubmitSearch() {
        this.submitSearch.emit(this.searchKeyword.value);
    }

    resetInputs() {
        this.searchKeyword.setValue('');
    }
}
